import { useMutation } from "react-query";
import { axiosClient } from "../../../core/services/axiosInstance";

const useUpdateKeywords = () => {
  const mutation = useMutation((formData) => {
    return axiosClient.post("/DocumentTypeKey/SaveDocumentKeyWord", formData);
  });
  return mutation;
};
export default useUpdateKeywords;
